import Vue from 'vue';
import VueRouter from 'vue-router';
import ResetPasswordSuccess from '@/views/ResetPasswordSuccess.vue';

Vue.use(VueRouter);

//showNav:是否显示--免费注册，用户登录的导航栏
const routes = [
  // {
  //   path: '/',
  //   name: 'Home',
  //   component: () => import('@/views/Home.vue'),
  //   meta: { showNav: true },
  // },
  // {
  //   path: '/exam',
  //   name: 'Exam',
  //   component: () => import('@/views/exam/OnlineRegistration.vue'),
  //   meta: { showNav: true },
  // },
  {
    path: '/',
    name: 'Exam/:token?/:userName?/:userId?/:phone?',
    component: () => import('@/views/exam/OnlineRegistration.vue'),
    meta: { showNav: false, type: 1 },
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/Login.vue'),
    meta: { showNav: false },
  },
  {
    path: '/findRegisNum',
    name: 'findRegisNum',
    component: () => import('@/views/findRegisNum.vue'),
    meta: { showNav: false },
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import('@/views/Register.vue'),
    meta: { showNav: false },
  },
  {
    path: '/exam-registration',
    name: 'ExamRegistration',
    component: () => import('@/views/ExamRegistration.vue'),
    meta: { showNav: false },
  },
  {
    path: '/exam/detail/:examId?/:type?/:flag?',
    name: 'ExamDetail',
    component: () => import('@/views/exam/examDetail.vue'),
    meta: { showNav: false, type: 1 },
  },
  {
    path: '/reset-password',
    name: 'ResetPassword',
    component: () => import('@/views/ResetPassword.vue'),
    meta: { showNav: false },
  },
  {
    path: '/reset-password-success',
    name: 'ResetPasswordSuccess',
    component: ResetPasswordSuccess,
  },
  {
    path: '/candidate-registrate/exam-documents/:examId?',
    name: 'ExamDocuments',
    component: () => import('@/views/candidateRegistrate/examDocuments.vue'),
    meta: { showNav: false },
  },
  {
    path: '/candidate-registrate/basic-info',
    name: 'BasicInfo',
    component: () => import('@/views/candidateRegistrate/BasicInfo.vue'),
    meta: { showNav: false },
  },
  {
    path: '/photo-upload',
    name: 'PhotoUpload',
    component: () => import('@/views/candidateRegistrate/PhotoUpload.vue'),
    meta: { showNav: false },
  },
  {
    path: '/document-upload',
    name: 'DocumentUpload',
    component: () => import('@/views/candidateRegistrate/DocumentUpload.vue'),
    meta: { showNav: false },
  },
  {
    path: '/document-download',
    name: 'DocumentDownLoad',
    component: () => import('@/views/candidateRegistrate/DocumentDownLoad.vue'),
    meta: { showNav: false },
  },
  {
    path: '/info-confirm',
    name: 'InfoConfirm',
    component: () => import('@/views/candidateRegistrate/InfoConfirm.vue'),
    meta: { showNav: false },
  },
  //信息维护
  {
    path: '/info-maintain',
    name: 'InfoMaintain',
    component: () => import('@/views/candidateRegistrate/InfoMaintain.vue'),
    meta: { showNav: false },
  },
  {
    path: '/print-ticket',
    name: 'PrintTicket',
    component: () => import('@/views/candidateRegistrate/PrintTicket.vue'),
    meta: { showNav: false },
  },
  //打印报名表1
  {
    path: '/print-ticket/printTicketView',
    name: 'printTicketView',
    component: () => import('@/views/candidateRegistrate/printTicketView.vue'),
    meta: { showNav: false },
  },
  {
    path: '/score-query',
    name: 'ScoreQuery',
    component: () => import('@/views/candidateRegistrate/ScoreQuery.vue'),
    meta: { showNav: false },
  },
  {
    path: '/register-success',
    name: 'RegisterSuccess',
    component: () => import('@/views/RegisterSuccess.vue'),
    meta: { showNav: false },
  },
  {
    path: '/candidate-registrate/basic-info/register-notice',
    name: 'RegisterNotice',
    component: () =>
      import('@/views/candidateRegistrate/BasicInfo/registerNotice.vue'),
    meta: { showNav: false },
  },
  /////////////////////资格审核  考试报名-详细信息
  {
    path: '/qualificationReview/reviewInfoDetail',
    name: 'reviewInfoDetail',
    component: () => import('@/views/qualificationReview/reviewInfoDetail.vue'),
    meta: { showNav: false },
  },
  /////////////////////打印准考证  考试报名-打印准考证
  {
    path: '/printAdmissionTicket/printTicket',
    name: 'printTicket',
    component: () => import('@/views/printAdmissionTicket/index.vue'),
    meta: { showNav: false },
  },
  //打印准考证2
  {
    path: '/printAdmissionTicket/printAdmissionView',
    name: 'printAdmissionView',
    component: () =>
      import('@/views/printAdmissionTicket/printAdmissionView.vue'),
    meta: { showNav: false },
  },
  /////////////////////考生缴费  考试报名-网上缴费
  {
    path: '/examineePayment/onlinePay',
    name: 'onlinePay',
    component: () => import('@/views/examineePayment/onlinePay.vue'),
    meta: { showNav: false },
  },
  /////////////////////成绩查询  考试报名-成绩查询
  {
    path: '/queryGradesModel/printGrades',
    name: 'printGrades',
    component: () => import('@/views/queryGradesModel/index.vue'),
    meta: { showNav: false },
  },
  //打印成绩单3
  {
    path: '/queryGradesModel/consoleGrades',
    name: 'consoleGrades',
    component: () => import('@/views/queryGradesModel/printGradesView.vue'),
    meta: { showNav: false },
  },
  /////////////////////个人中心
  {
    path: '/user/profile/setting',
    name: 'printGrades',
    component: () => import('@/views/user/profile/index.vue'),
    meta: { showNav: false },
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

export default router;
